import { ConnectWalletButton } from "module/wallet/component/ConnectWalletButton"

import { Box, Heading, Text, VStack } from "@chakra-ui/react"
import { MotionBox, MotionImage, MotionVStack } from "component/Motion"

import { NewsFeed } from "../NewsFeed"

export function Landing() {
    return (
        <MotionVStack spacing={10} width={"100%"}>
            <VStack spacing={10} width="100%">
                <MotionBox
                    animate={{ opacity: 1, y: 0, transition: { delay: 0.3, duration: 0.6, ease: "easeInOut" } }}
                    initial={{ opacity: 0, y: 60 }}
                    mt={"30px"}
                    mb="10px"
                    borderRadius="full"
                    w={["80px", "140px"]}
                    h={["80px", "140px"]}
                    position="relative"
                >
                    <MotionImage
                        w={["80px", "140px"]}
                        h={["80px", "140px"]}
                        position="absolute"
                        left="0"
                        top="0"
                        zIndex={1}
                        src="/assets/competition/v2front.png"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1, transition: { delay: 1, duration: 1 } }}
                    />
                    <MotionImage
                        w={["80px", "140px"]}
                        h={["80px", "140px"]}
                        position="absolute"
                        left="0"
                        top="0"
                        zIndex={0}
                        src="/assets/competition/v2back.png"
                        animate={{
                            rotate: 360,
                            transition: {
                                repeat: Infinity,
                                duration: 64,
                                repeatType: "loop",
                                type: "tween",
                                ease: "linear",
                            },
                        }}
                    />
                </MotionBox>
                <MotionVStack
                    align="stretch"
                    spacing={4}
                    animate={{ opacity: 1, y: 0, transition: { delay: 0.4, duration: 0.6, ease: "easeInOut" } }}
                    initial={{ opacity: 0, y: 60 }}
                >
                    <VStack spacing={0} width="100%">
                        <Text fontFamily="brand" pb={2} fontSize="sm" color="gray.400">
                            v2 Curie
                        </Text>
                        <Heading size={"4xl"} fontFamily="brand" pb={2} textAlign={"center"}>
                            Perpetual Protocol
                        </Heading>
                        <Heading pt={4} fontFamily="brand" pb={2} size="2xl" textAlign={"center"}>
                            <Text as="span" color="rgba(57, 212, 154, 1.000)">
                                Trade. {""}
                            </Text>

                            <Text as="span" color="rgba(6, 190, 220, 1.000)">
                                Create. {""}
                            </Text>

                            <Text as="span" color="rgba(213, 180, 246, 1.000)">
                                Market Make.
                            </Text>
                        </Heading>
                        <Text pt={4} opacity={0.65} fontSize={"md"} textAlign={"center"}>
                            Cross margin DeFi trading with up to 10×-leverage.
                        </Text>
                    </VStack>
                    <Box pt={10}>
                        <ConnectWalletButton size={"md"} colorScheme="perpetual" width="full" />
                    </Box>
                </MotionVStack>
            </VStack>

            <MotionImage
                animate={{ opacity: 1, y: 0, transition: { delay: 0.4, duration: 0.6, ease: "easeInOut" } }}
                initial={{ opacity: 0, y: 60 }}
                m="0 auto"
                py={10}
                w={"22px"}
                src="/assets/competition/dotline.svg"
            />

            <NewsFeed colOverride={2} />
        </MotionVStack>
    )
}
